<template>
    <div class="toggle btn btn-primary toggle-checkbox" :class="{off: !isChecked}"  @click.stop="toggle" >
        <input type="hidden" :name="this.name" :id="this.name" :value="checkboxValue">
        <div class="toggle-group">
            <label class="btn btn-success toggle-on" v-text="onText" ></label>
            <label class="btn btn-danger toggle-off"  v-text="offText"></label>
            <span class="toggle-handle btn btn-white"></span>
        </div>
    </div>
</template>
<script>
    export default{
        props: ['name','onText','offText','initialValue'],
        data(){
            return{
                isChecked : this.initialValue == 1 ? true: false,
                checkboxValue : this.initialValue
            }
        },
        methods: {
         toggle(){
             this.isChecked = !this.isChecked;
               if(this.isChecked){
                    this.checkboxValue = 1;
               } else {
                      this.checkboxValue = 0;
               }
            }
        },
    }
</script>

